var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionedFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.6H10.875L6.75 1.2V5.6ZM1.5 0H7.5L12 4.8V14.4C12 14.8243 11.842 15.2313 11.5607 15.5314C11.2794 15.8314 10.8978 16 10.5 16H1.5C0.6675 16 0 15.28 0 14.4V1.6C0 0.712 0.6675 0 1.5 0ZM6.12 9.848C4.95 9.848 3.8925 10.312 3.0825 11.064L1.5 9.376V13.6H5.46L3.8625 11.904C4.4775 11.36 5.25 11.024 6.12 11.024C7.6725 11.024 9 12.104 9.4575 13.6L10.5 13.232C9.8925 11.272 8.16 9.848 6.12 9.848Z",
    fill: "#A1B3C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionedFile);
export default __webpack_public_path__ + "static/media/versioned-file.b12d3aaa2cbb33b6ffb656c3c5b917ea.svg";
export { ForwardRef as ReactComponent };